// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2K2fw","title":"Header_title__2BK5x","side":"Header_side__1BWtK"};